import { defineMessages } from 'react-intl'

export default defineMessages(
  {
    username: {
      id: 'username',
      defaultMessage: 'Username'
    },
    password: {
      id: 'password',
      defaultMessage: 'Password'
    },
    enter_password: {
      id: 'enter_password',
      defaultMessage: 'Enter password'
    },
    enter_username: {
      id: 'enter_username',
      defaultMessage: 'Enter username'
    },
    network_error: {
      id: 'Network Error',
      defaultMessage: 'Network Error'
    },
    UNDEFINED_ERROR: {
      id: 'UNDEFINED_ERROR',
      defaultMessage: 'Undefined error'
    },
    WRONG_JSON: {
      id: 'WRONG_JSON',
      defaultMessage: 'Incorrect request format'
    },
    INVALID_CREDENTIALS: {
      id: 'INVALID_CREDENTIALS',
      defaultMessage: 'Incorrect username or password'
    },
    USERNAME_NOT_CORRECT: {
      id: 'USERNAME_NOT_CORRECT',
      defaultMessage: 'Invalid object: username field is empty or null'
    },
    createDate: {
      id: 'createDate',
      defaultMessage: 'Creation date'
    },
    updateDate: {
      id: 'updateDate',
      defaultMessage: 'Update date'
    },
    name: {
      id: 'name',
      defaultMessage: 'Name'
    },
    type: {
      id: 'type',
      defaultMessage: 'Type'
    },
    enter_id: {
      id: 'enter_id',
      defaultMessage: 'Enter ID'
    },
    enter_name: {
      id: 'enter_name',
      defaultMessage: 'Enter name'
    },
    enter_surname: {
      id: 'enter_surname',
      defaultMessage: 'Enter surname'
    },
    enter_value: {
      id: 'enter_value',
      defaultMessage: 'Enter value'
    },
    enter_path: {
      id: 'enter_path',
      defaultMessage: 'Enter path'
    },
    date: {
      id: 'date',
      defaultMessage: 'date'
    },
    lifetime: {
      id: 'lifetime',
      defaultMessage: 'Deletion time'
    },
    version: {
      id: 'version',
      defaultMessage: 'Version'
    },
    parameters: {
      id: 'parameters',
      defaultMessage: 'Parameters'
    },
    all: {
      id: 'all',
      defaultMessage: 'all'
    },
    FILE_NOT_FOUND: {
      id: 'FILE_NOT_FOUND',
      defaultMessage: 'File not found'
    },
    ILLEGAL_ARGUMENT: {
      id: 'ILLEGAL_ARGUMENT',
      defaultMessage: 'Invalid input data format'
    },
    cant_download_file: {
      id: 'cant_download_file',
      defaultMessage: 'Failed to download file'
    },
    NOT_ENOUGH_MEMORY: {
      id: 'NOT_ENOUGH_MEMORY',
      defaultMessage: 'Not enough memory'
    },
    file_extension_wrong: {
      id: 'file_extension_wrong',
      defaultMessage: 'File extension is invalid. Allowed extensions: {permissibleExtensions}'
    },
    file_size_exceeded: {
      id: 'file_size_exceeded',
      defaultMessage: 'Size limit exceeded. Maximum file size is {permissibleSizeMb} MB'
    },
    delete_filter: {
      id: 'delete_filter',
      defaultMessage: 'Delete filter'
    },
    collapse: {
      id: 'collapse',
      defaultMessage: 'Collapse'
    },
    expand: {
      id: 'expand',
      defaultMessage: 'Expand'
    },
    no_domains: {
      id: 'no_domains',
      defaultMessage: 'No available domains'
    },
    enter_file_id: {
      id: 'enter_file_id',
      defaultMessage: 'Enter file ID'
    },
    delete: {
      id: 'delete',
      defaultMessage: 'Delete'
    },
    by_face: {
      id: 'by_face',
      defaultMessage: 'by face'
    },
    by_voice: {
      id: 'by_voice',
      defaultMessage: 'by voice'
    },
    face: {
      id: 'face',
      defaultMessage: 'Face'
    },
    profile_id: {
      id: 'profile_id',
      defaultMessage: 'profile ID'
    },
    enter_profile_id: {
      id: 'enter_profile_id',
      defaultMessage: 'Enter profile ID'
    },
    profile_create_success: {
      id: 'profile_create_success',
      defaultMessage: 'Profile created'
    },
    profile_delete_success: {
      id: 'profile_delete_success',
      defaultMessage: 'Profile deleted'
    },
    audio_player_fail: {
      id: 'audio_player_fail',
      defaultMessage: 'Audio player error'
    },
    group_create_success: {
      id: 'group_create_success',
      defaultMessage: 'Group created'
    },
    group_create_fail: {
      id: 'group_create_fail',
      defaultMessage: 'Failed to create group'
    },
    group_delete_fail: {
      id: 'group_delete_fail',
      defaultMessage: 'Failed to delete group'
    },
    group_delete_success: {
      id: 'group_delete_success',
      defaultMessage: 'Group deleted'
    },
    group_get_profiles_fail: {
      id: 'group_get_profiles_fail',
      defaultMessage: 'Failed to get group profiles'
    },
    enter_group_name: {
      id: 'enter_group_name',
      defaultMessage: 'Enter group name'
    },
    delete_profile_from_group: {
      id: 'delete_profile_from_group',
      defaultMessage: 'Delete profile from group'
    },
    get_groups_fail: {
      id: 'get_groups_fail',
      defaultMessage: 'Failed to get groups'
    },
    delete_profile: {
      id: 'delete_profile',
      defaultMessage: 'Delete profile'
    },
    template_create_success: {
      id: 'template_create_success',
      defaultMessage: 'Template created'
    },
    DATA_CORRUPTED: {
      id: 'DATA_CORRUPTED',
      defaultMessage: 'Data corrupted'
    },
    delete_candidate: {
      id: 'delete_candidate',
      defaultMessage: 'Delete candidate'
    },
    start_typing: {
      id: 'start_typing',
      defaultMessage: 'Start typing {itemName}'
    },
    upload_photo: {
      id: 'upload_photo',
      defaultMessage: 'Upload photo'
    },
    take_photo: {
      id: 'take_photo',
      defaultMessage: 'Take a photo'
    },
    upload_audio: {
      id: 'upload_audio',
      defaultMessage: 'Upload audio'
    },
    record_audio: {
      id: 'record_audio',
      defaultMessage: 'Record audio'
    },
    candidates: {
      id: 'candidates',
      defaultMessage: 'Candidates'
    },
    groups_for_comparison: {
      id: 'groups_for_comparison',
      defaultMessage: 'Groups for comparison'
    },
    results: {
      id: 'results',
      defaultMessage: 'Results'
    },
    no_references_in_comparison: {
      id: 'no_references_in_comparison',
      defaultMessage: 'No reference added to comparison'
    },
    some_reference_groups_not_added_to_comparison: {
      id: 'some_reference_groups_not_added_to_comparison',
      defaultMessage: 'Some groups of references are not added to comparison{groupNames}'
    },
    some_candidate_groups_not_added_to_comparison: {
      id: 'some_candidate_groups_not_added_to_comparison',
      defaultMessage: 'Some groups of candidates are not added to comparison{groupNames}'
    },
    some_candidate_persons_not_added_to_comparison: {
      id: 'some_candidate_persons_not_added_to_comparison',
      defaultMessage: 'Some candidates are not added to comparison'
    },
    some_reference_persons_not_added_to_comparison: {
      id: 'some_reference_persons_not_added_to_comparison',
      defaultMessage: 'Some references not added to comparison'
    },
    no_candidates_in_comparison: {
      id: 'no_candidates_in_comparison',
      defaultMessage: 'No candidates added to comparison'
    },
    PERSON_NOT_FOUND: {
      id: 'PERSON_NOT_FOUND',
      defaultMessage: 'Person not found'
    },
    FACE_MODEL_ALREADY_EXIST: {
      id: 'FACE_MODEL_ALREADY_EXIST',
      defaultMessage: 'Face template already exists'
    },
    VOICE_MODEL_ALREADY_EXIST: {
      id: 'VOICE_MODEL_ALREADY_EXIST',
      defaultMessage: 'Voice template already exists'
    },
    NO_FACES_FOUND: {
      id: 'NO_FACES_FOUND',
      defaultMessage: 'No faces found in the photo'
    },
    FACE_IS_NOT_POSITIONED_FRONTAL: {
      id: 'FACE_IS_NOT_POSITIONED_FRONTAL',
      defaultMessage: 'Face is not in frontal position'
    },
    NO_MODEL: {
      id: 'NO_MODEL',
      defaultMessage: 'There is no template'
    },
    no_connected_device: {
      id: 'no_connected_device',
      defaultMessage: 'Failed to connect the device'
    },
    stop_record: {
      id: 'stop_record',
      defaultMessage: 'Stop recording'
    },
    start_record: {
      id: 'start_record',
      defaultMessage: 'Start recording'
    },
    clean: {
      id: 'clean',
      defaultMessage: 'Clean'
    },
    candidates_delete_success: {
      id: 'candidates_delete_success',
      defaultMessage: '{itemsCount, plural, one {Candidate} other {Candidates}} {itemsCount, plural, one {deleted} other {deleted}}'
    },
    references_delete_success: {
      id: 'references_delete_success',
      defaultMessage: '{itemsCount, plural, one {Reference} other {References}} {itemsCount, plural, one {deleted} other {deleted}}'
    },
    undefined_message: {
      id: 'undefined_message',
      defaultMessage: 'Undefined message'
    },
    comparison_fail: {
      id: 'comparison_fail',
      defaultMessage: 'Comparison failed'
    },
    get_processor_profile_fail: {
      id: 'get_processor_profile_fail',
      defaultMessage: 'Failed to get processor profile'
    },
    group_update_register_status_fail: {
      id: 'group_update_register_status_fail',
      defaultMessage: 'Failed to update registration status of {groupNames} {itemsCount, plural, one {group} other {groups}}'
    },
    group_change_register_status_fail: {
      id: 'group_change_register_status_fail',
      defaultMessage: 'Failed to change group registration status'
    },
    group_delete_profile_fail: {
      id: 'group_delete_profile_fail',
      defaultMessage: 'Failed to delete profile from group'
    },
    group_add_profile_fail: {
      id: 'group_add_profile_fail',
      defaultMessage: 'Failed to add {personIds} {itemsCount, plural, one {profile} other {profiles}} to group'
    },
    media_load_fail: {
      id: 'media_load_fail',
      defaultMessage: 'Uploading media data failed'
    },
    profile_load_groups_fail: {
      id: 'profile_load_groups_fail',
      defaultMessage: 'Failed to load list of profile groups'
    },
    profile_create_template_fail: {
      id: 'profile_create_template_fail',
      defaultMessage: 'Failed to create profile template'
    },
    profile_delete_fail: {
      id: 'profile_delete_fail',
      defaultMessage: 'Failed to delete profile'
    },
    profile_get_all_fail: {
      id: 'profile_get_all_fail',
      defaultMessage: 'Failed to get profiles'
    },
    TINTED_GLASS_DETECTED: {
      id: 'TINTED_GLASS_DETECTED',
      defaultMessage: 'Tinted eyeglasses detected'
    },
    EYES_ARE_CLOSED: {
      id: 'EYES_ARE_CLOSED',
      defaultMessage: 'Eyes closed'
    },
    TOO_MANY_FACES_FOUND: {
      id: 'TOO_MANY_FACES_FOUND',
      defaultMessage: 'Too many faces found'
    },
    FACE_IMAGE_EMPTY: {
      id: 'FACE_IMAGE_EMPTY',
      defaultMessage: 'Face image is empty'
    },
    FILE_CORRUPTED: {
      id: 'FILE_CORRUPTED',
      defaultMessage: 'File corrupted'
    },
    INSUFFICIENT_SIZE: {
      id: 'INSUFFICIENT_SIZE',
      defaultMessage: 'The image file size is smaller than minimum required'
    },
    INSUFFICIENT_SPEECH_DURATION: {
      id: 'INSUFFICIENT_SPEECH_DURATION',
      defaultMessage: 'Insufficient amount of pure speech'
    },
    LOW_DISTANCE_BETWEEN_EYES: {
      id: 'LOW_DISTANCE_BETWEEN_EYES',
      defaultMessage: 'Distance between eyes is less than minimum required'
    },
    PORTRAIT_FAILURE: {
      id: 'PORTRAIT_FAILURE',
      defaultMessage: 'Failed to identify face boundaries'
    },
    SAMPLE_CORRUPTED: {
      id: 'SAMPLE_CORRUPTED',
      defaultMessage: 'Sample corrupted'
    },
    VOICE_FILE_EMPTY: {
      id: 'VOICE_FILE_EMPTY',
      defaultMessage: 'Voice file empty'
    },
    PASSWORD_HAS_EXPIRED: {
      id: 'PASSWORD_HAS_EXPIRED',
      defaultMessage: 'Password expired'
    },
    LICENSE_RESTRICTION: {
      id: 'LICENSE_RESTRICTION',
      defaultMessage: 'License restriction'
    },
    PROFILE_MISMATCH: {
      id: 'PROFILE_MISMATCH',
      defaultMessage: 'Processor profile mismatch'
    },
    TRANSPORT_ERROR: {
      id: 'TRANSPORT_ERROR',
      defaultMessage: 'Error of system components interaction. Please retry later'
    },
    NO_NEIGHBOURS: {
      id: 'NO_NEIGHBOURS',
      defaultMessage: 'Internal server error'
    },
    MESSAGE_META_CORRUPTED: {
      id: 'MESSAGE_META_CORRUPTED',
      defaultMessage: 'Internal server error'
    },
    DUPLICATE_GROUP: {
      id: 'DUPLICATE_GROUP',
      defaultMessage: 'Group with the same name already exists'
    },
    GROUP_NOT_FOUND: {
      id: 'GROUP_NOT_FOUND',
      defaultMessage: 'Group not found'
    },
    SESSION_INVALID_OR_EXPIRED: {
      id: 'SESSION_INVALID_OR_EXPIRED',
      defaultMessage: 'Session is invalid'
    },
    GROUP_NOT_REGISTERED: {
      id: 'GROUP_NOT_REGISTERED',
      defaultMessage: 'Group is not registered'
    },
    first_name: {
      id: 'first_name',
      defaultMessage: 'First Name'
    },
    last_name: {
      id: 'last_name',
      defaultMessage: 'Last Name'
    },
    display_name: {
      id: 'display_name',
      defaultMessage: 'Display Name'
    },
    email: {
      id: 'email',
      defaultMessage: 'Email'
    },
    directory: {
      id: 'directory',
      defaultMessage: 'Directory'
    },
    delete_session: {
      id: 'delete_session',
      defaultMessage: 'Delete session'
    },
    session_delete_failed: {
      id: 'session_delete_failed',
      defaultMessage: 'Session not deleted'
    },
    session_deleted: {
      id: 'session_deleted',
      defaultMessage: 'Session deleted'
    },
    get_session_failed: {
      id: 'get_session_failed',
      defaultMessage: 'Failed to get list of sessions'
    },
    create_user_failed: {
      id: 'create_user_failed',
      defaultMessage: 'Create user failed'
    },
    domain_name: {
      id: 'domain_name',
      defaultMessage: 'Domain name'
    },
    delete_domain: {
      id: 'delete_domain',
      defaultMessage: 'Delete domain'
    },
    domain_create_failed: {
      id: 'domain_create_failed',
      defaultMessage: 'Failed to create domain'
    },
    domain_created: {
      id: 'domain_created',
      defaultMessage: 'Domain created'
    },
    domain_deleted: {
      id: 'domain_deleted',
      defaultMessage: 'Domain deleted'
    },
    domain_delete_failed: {
      id: 'domain_delete_failed',
      defaultMessage: 'Failed to delete domain'
    },
    domain_updated: {
      id: 'domain_updated',
      defaultMessage: 'Domain updated'
    },
    domain_update_failed: {
      id: 'domain_update_failed',
      defaultMessage: 'Failed to update domain'
    },
    DUPLICATE_DOMAIN: {
      id: 'DUPLICATE_DOMAIN',
      defaultMessage: 'Domain with the same name already exists'
    },
    delete_role: {
      id: 'delete_role',
      defaultMessage: 'Delete role'
    },
    perpetual: {
      id: 'perpetual',
      defaultMessage: 'Perpetual'
    },
    role_create_failed: {
      id: 'role_create_failed',
      defaultMessage: 'Failed to create role'
    },
    role_created: {
      id: 'role_created',
      defaultMessage: 'Role created'
    },
    role_deleted: {
      id: 'role_deleted',
      defaultMessage: 'Role deleted'
    },
    role_delete_failed: {
      id: 'role_delete_failed',
      defaultMessage: 'Failed to delete role'
    },
    role_updated: {
      id: 'role_updated',
      defaultMessage: 'Role updated'
    },
    role_update_failed: {
      id: 'role_update_failed',
      defaultMessage: 'Failed to update role'
    },
    DUPLICATE_ROLE: {
      id: 'DUPLICATE_ROLE',
      defaultMessage: 'Role with the same name already exists'
    },
    delete_position: {
      id: 'delete_position',
      defaultMessage: 'Delete position'
    },
    position_create_failed: {
      id: 'position_create_failed',
      defaultMessage: 'Failed to create position'
    },
    position_created: {
      id: 'position_created',
      defaultMessage: 'Position created'
    },
    position_deleted: {
      id: 'position_deleted',
      defaultMessage: 'Position deleted'
    },
    position_delete_failed: {
      id: 'position_delete_failed',
      defaultMessage: 'Failed to delete position'
    },
    position_updated: {
      id: 'position_updated',
      defaultMessage: 'Position updated'
    },
    position_update_failed: {
      id: 'position_update_failed',
      defaultMessage: 'Failed to update position'
    },
    DUPLICATE_POSITION: {
      id: 'DUPLICATE_POSITION',
      defaultMessage: 'Position with the same name already exists'
    },
    delete_user: {
      id: 'delete_user',
      defaultMessage: 'Delete user'
    },
    user_create_failed: {
      id: 'user_create_failed',
      defaultMessage: 'Failed to create user'
    },
    user_created: {
      id: 'user_created',
      defaultMessage: 'User created'
    },
    user_deleted: {
      id: 'user_deleted',
      defaultMessage: 'User deleted'
    },
    user_delete_failed: {
      id: 'user_delete_failed',
      defaultMessage: 'Failed to delete user'
    },
    user_updated: {
      id: 'user_updated',
      defaultMessage: 'User updated'
    },
    user_update_failed: {
      id: 'user_update_failed',
      defaultMessage: 'Failed to update user update'
    },
    user_blocked: {
      id: 'user_blocked',
      defaultMessage: 'User blocked'
    },
    user_unblocked: {
      id: 'user_unblocked',
      defaultMessage: 'User unblocked'
    },
    user_block_failed: {
      id: 'user_block_failed',
      defaultMessage: 'Failed to block user'
    },
    user_unblock_failed: {
      id: 'user_unblock_failed',
      defaultMessage: 'Failed to unblock user'
    },
    user_password_changed: {
      id: 'user_password_changed',
      defaultMessage: 'User password changed'
    },
    user_password_changed_failed: {
      id: 'user_password_changed_failed',
      defaultMessage: 'Failed to change user password'
    },
    DUPLICATE_USER: {
      id: 'DUPLICATE_USER',
      defaultMessage: 'User is already registered'
    },
    delete_key: {
      id: 'delete_key',
      defaultMessage: 'Delete key'
    },
    key_create_failed: {
      id: 'key_create_failed',
      defaultMessage: 'Failed to create the key'
    },
    key_created: {
      id: 'key_created',
      defaultMessage: 'Key created'
    },
    key_deleted: {
      id: 'key_deleted',
      defaultMessage: 'Key deleted'
    },
    key_delete_failed: {
      id: 'key_delete_failed',
      defaultMessage: 'Failed to delete the key'
    },
    key_updated: {
      id: 'key_updated',
      defaultMessage: 'Key updated'
    },
    key_update_failed: {
      id: 'key_update_failed',
      defaultMessage: 'Failed to update the key'
    },
    key_blocked: {
      id: 'key_blocked',
      defaultMessage: 'Key blocked'
    },
    get_keys_failed: {
      id: 'get_keys_failed',
      defaultMessage: 'Failed to get keys'
    },
    key_unblocked: {
      id: 'key_unblocked',
      defaultMessage: 'Key unblocked'
    },
    key_block_failed: {
      id: 'key_block_failed',
      defaultMessage: 'Failed to block the key'
    },
    key_unblock_failed: {
      id: 'key_unblock_failed',
      defaultMessage: 'Failed to unblock the key'
    },
    block: {
      id: 'block',
      defaultMessage: 'Block'
    },
    unblock: {
      id: 'unblock',
      defaultMessage: 'Unblock'
    },
    USER_UPDATE_INVALID_ARGUMENTS: {
      id: 'USER_UPDATE_INVALID_ARGUMENTS',
      defaultMessage: 'Invalid data while updating the user'
    },
    NULL_OR_EMPTY_PASSWORD: {
      id: 'NULL_OR_EMPTY_PASSWORD',
      defaultMessage: 'Impossible to access the system. Password field is empty'
    },
    close: {
      id: 'close',
      defaultMessage: 'Close'
    },
    previous_page: {
      id: 'previous_page',
      defaultMessage: 'Previous page'
    },
    next_page: {
      id: 'next_page',
      defaultMessage: 'Next page'
    },
    id: {
      id: 'id',
      defaultMessage: 'ID'
    },
    data_types_get_failed: {
      id: 'data_types_get_failed',
      defaultMessage: 'Failed to retrieve data types'
    },
    edit: {
      id: 'edit',
      defaultMessage: 'Edit'
    },
    INTERNAL_SERVER_ERROR: {
      id: 'INTERNAL_SERVER_ERROR',
      defaultMessage: 'Internal server error'
    },
    PRIVILEGE_REQUIRED: {
      id: 'PRIVILEGE_REQUIRED',
      defaultMessage: 'Missing required privilege'
    },
    searching_fail: {
      id: 'searching_fail',
      defaultMessage: 'Search failed'
    },
    no_files_found: {
      id: 'no_files_found',
      defaultMessage: 'No files found'
    },
    authorization_fail: {
      id: 'authorization_fail',
      defaultMessage: 'Authorization failed'
    },
    domains_get_fail: {
      id: 'domains_get_fail',
      defaultMessage: 'Failed to get domains'
    },
    WEB_EXCEPTION: {
      id: 'WEB_EXCEPTION',
      defaultMessage: 'Request error'
    },
    show_items_per_page: {
      id: 'show_items_per_page',
      defaultMessage: 'Show items per page'
    },
    unable_get_document_types: {
      id: 'unable_get_document_types',
      defaultMessage: 'Failed to get document types'
    },
    RUS_NATIONAL_PASSPORT: {
      id: 'RUS_NATIONAL_PASSPORT',
      defaultMessage: 'Russian national passport'
    },
    RUS_BIOMETRIC_PASSPORT: {
      id: 'RUS_BIOMETRIC_PASSPORT',
      defaultMessage: 'Russian biometric passport'
    },
    unable_recognize_photo: {
      id: 'unable_recognize_photo',
      defaultMessage: 'Failed to recognize photo'
    },
    files_count_exceeded: {
      id: 'files_count_exceeded',
      defaultMessage: 'Number of downloaded files is exceeded. Maximum number is {maxFilesCount}'
    },
    unable_get_privileges: {
      id: 'unable_get_privileges',
      defaultMessage: 'Failed to get list of privileges'
    },
    TOO_LONG_GROUP_NAME: {
      id: 'TOO_LONG_GROUP_NAME',
      defaultMessage: 'Group name is too long'
    },
    directories: {
      id: 'directories',
      defaultMessage: 'Directories'
    },
    delete_mapping: {
      id: 'delete_mapping',
      defaultMessage: 'Delete mapping'
    },
    mapping_create_failed: {
      id: 'mapping_create_failed',
      defaultMessage: 'Failed to create mapping'
    },
    mapping_created: {
      id: 'mapping_created',
      defaultMessage: 'Mapping created'
    },
    mapping_deleted: {
      id: 'mapping_deleted',
      defaultMessage: 'Mapping deleted'
    },
    mapping_delete_failed: {
      id: 'mapping_delete_failed',
      defaultMessage: 'Failed to delete mapping'
    },
    matched_users_count: {
      id: 'matched_users_count',
      defaultMessage: 'Matched users count'
    },
    users_in_all_users_group_count: {
      id: 'users_in_all_users_group_count',
      defaultMessage: 'Users in all users group count'
    },
    synchronize_success: {
      id: 'synchronize_success',
      defaultMessage: 'Synchronization completed'
    },
    synchronize_failed: {
      id: 'synchronize_failed',
      defaultMessage: 'Synchronization failed'
    },
    LDAP_GROUP_TO_POSITION_MAPPING_EXIST: {
      id: 'LDAP_GROUP_TO_POSITION_MAPPING_EXIST',
      defaultMessage: 'Such LDAP group-to-position mapping already exists'
    },
    drag_file_here: {
      id: 'drag_file_here',
      defaultMessage: 'Drag {filesCount, plural, one {file} other {files}} here'
    },
    add: {
      id: 'add',
      defaultMessage: 'Add'
    },
    PASSWORD_TOO_SHORT: {
      id: 'PASSWORD_TOO_SHORT',
      defaultMessage: 'Password is too short'
    },
    PASSWORD_TOO_LONG: {
      id: 'PASSWORD_TOO_LONG',
      defaultMessage: 'Invalid password: Password is too long'
    },
    PASSWORD_DOES_NOT_HAVE_UPPERCASE: {
      id: 'PASSWORD_DOES_NOT_HAVE_UPPERCASE',
      defaultMessage: 'Not enough uppercase characters in password'
    },
    PASSWORD_DOES_NOT_HAVE_LOWERCASE: {
      id: 'PASSWORD_DOES_NOT_HAVE_LOWERCASE',
      defaultMessage: 'Not enough lowercase characters in password'
    },
    PASSWORD_DOES_NOT_HAVE_NON_ALPHANUMERIC_CHARACTER: {
      id: 'PASSWORD_DOES_NOT_HAVE_NON_ALPHANUMERIC_CHARACTER',
      defaultMessage: 'Not enough non-alphanumeric characters in password'
    },
    PASSWORD_DOES_NOT_HAVE_DIGIT: {
      id: 'PASSWORD_DOES_NOT_HAVE_DIGIT',
      defaultMessage: 'Not enough digits in password'
    },
    PASSWORD_WAS_USED_EARLIER: {
      id: 'PASSWORD_WAS_USED_EARLIER',
      defaultMessage: 'Invalid password: Password was used before'
    },
    USER_DIRECTORY_DISABLED: {
      id: 'USER_DIRECTORY_DISABLED',
      defaultMessage: 'Specified user directory is disabled by system administrator'
    },
    ADMIN_POSITION_MAPPING_NOT_ACCEPTABLE: {
      id: 'ADMIN_POSITION_MAPPING_NOT_ACCEPTABLE',
      defaultMessage: 'Creating mapping to LDAP group is not available for Administrator position'
    },
    API_KEY_CREATE_INVALID_ARGUMENT: {
      id: 'API_KEY_CREATE_INVALID_ARGUMENT',
      defaultMessage: 'Invalid parameters were specified when creating the key'
    },
    API_KEY_UPDATE_INVALID_ARGUMENT: {
      id: 'API_KEY_UPDATE_INVALID_ARGUMENT',
      defaultMessage: 'An error occurred when editing the key. Possible error reasons: empty request, description is empty or contains more than 50 characters'
    },
    INVALID_EXPIRED_AT: {
      id: 'INVALID_EXPIRED_AT',
      defaultMessage: 'The date cannot be set earlier than the next day'
    },
    min_date: {
      id: 'min_date',
      defaultMessage: 'Date is less than minimum value'
    },
    max_date: {
      id: 'max_date',
      defaultMessage: 'Date greater than maximum'
    },
    invalid_date: {
      id: 'invalid_date',
      defaultMessage: 'Invalid Date'
    },
    person_border_offset: {
      id: 'person_border_offset',
      defaultMessage: 'Expand face image border, %'
    },
    unable_delete_file: {
      id: 'unable_delete_file',
      defaultMessage: 'Failed to delete file'
    },
    unable_load_next_file: {
      id: 'unable_load_next_file',
      defaultMessage: 'Failed to load the next file'
    },
    hour: {
      id: 'hour',
      defaultMessage: 'Hour'
    },
    day: {
      id: 'day',
      defaultMessage: 'Day'
    },
    month: {
      id: 'month',
      defaultMessage: 'Month'
    },
    quarter: {
      id: 'quarter',
      defaultMessage: 'Quarter'
    },
    year: {
      id: 'year',
      defaultMessage: 'Year'
    },
    DUPLICATE_FILE: {
      id: 'DUPLICATE_FILE',
      defaultMessage: 'File with the same name already exists'
    },
    file_upload_success: {
      id: 'file_upload_success',
      defaultMessage: '{itemsCount, plural, one {File is} other {Files are}} uploaded'
    },
    add_field: {
      id: 'add_field',
      defaultMessage: 'Add field'
    },
    unable_replace_file: {
      id: 'unable_replace_file',
      defaultMessage: 'Failed to replace file'
    },
    file_replaced: {
      id: 'file_replaced',
      defaultMessage: 'File replaced'
    },
    unable_update_file_data: {
      id: 'unable_update_file_data',
      defaultMessage: 'Failed to update file data'
    },
    WRONG_VERSION: {
      id: 'WRONG_VERSION',
      defaultMessage: 'Wrong file version'
    },
    unable_register_file_type: {
      id: 'unable_register_file_type',
      defaultMessage: 'Failed to register file type'
    },
    file_type_registered: {
      id: 'file_type_registered',
      defaultMessage: 'File type is registered'
    },
    DUPLICATE_FILE_TYPE: {
      id: 'DUPLICATE_FILE_TYPE',
      defaultMessage: 'File type with the same name already exists'
    },
    NO_MAPPINGS_CREATED: {
      id: 'NO_MAPPINGS_CREATED',
      defaultMessage: 'No LDAP group-to-position mapping is specified'
    },
    search: {
      id: 'search',
      defaultMessage: 'Search'
    },
    save: {
      id: 'save',
      defaultMessage: 'Save'
    },
    play: {
      id: 'play',
      defaultMessage: 'Play'
    },
    failed_to_synthesize_text: {
      id: 'failed_to_synthesize_text',
      defaultMessage: 'Failed to synthesize text'
    },
    failed_to_get_list_of_languages: {
      id: 'failed_to_get_list_of_languages',
      defaultMessage: 'Failed to get list of languages'
    },
    failed_to_get_list_of_voices: {
      id: 'failed_to_get_list_of_voices',
      defaultMessage: 'Failed to get list of voices'
    },
    failed_to_get_list_of_users: {
      id: 'failed_to_get_list_of_users',
      defaultMessage: 'Failed to get list of users'
    },
    failed_to_get_list_of_directories: {
      id: 'failed_to_get_list_of_directories',
      defaultMessage: 'Failed to get list of directories'
    },
    failed_to_get_list_of_positions: {
      id: 'failed_to_get_list_of_positions',
      defaultMessage: 'Failed to get list of positions'
    },
    failed_to_get_list_of_roles: {
      id: 'failed_to_get_list_of_roles',
      defaultMessage: 'Failed to get list of roles'
    },
    failed_to_get_list_of_domains: {
      id: 'failed_to_get_list_of_domains',
      defaultMessage: 'Failed to get list of domains'
    },
    failed_to_get_list_of_privileges: {
      id: 'failed_to_get_list_of_privileges',
      defaultMessage: 'Failed to get list of privileges'
    },
    failed_to_get_list_of_groups: {
      id: 'failed_to_get_list_of_groups',
      defaultMessage: 'Failed to get list of groups'
    },
    wrong_file_format: {
      id: 'wrong_file_format',
      defaultMessage: 'Wrong file format'
    },
    file_is_empty: {
      id: 'file_is_empty',
      defaultMessage: 'File is empty'
    },
    delete_vocabulary: {
      id: 'delete_vocabulary',
      defaultMessage: 'Delete vocabulary'
    },
    description: {
      id: 'description',
      defaultMessage: 'Description'
    },
    get_vocabularies_failed: {
      id: 'get_vocabularies_failed',
      defaultMessage: 'Failed to get list of vocabularies'
    },
    create_vocabulary_failed: {
      id: 'create_vocabulary_failed',
      defaultMessage: 'Failed to create vocabulary'
    },
    update_vocabulary_failed: {
      id: 'update_vocabulary_failed',
      defaultMessage: 'Failed to update vocabulary'
    },
    delete_vocabulary_failed: {
      id: 'delete_vocabulary_failed',
      defaultMessage: 'Failed to delete vocabulary'
    },
    get_words_failed: {
      id: 'get_words_failed',
      defaultMessage: 'Failed to get list of words'
    },
    vocabulary_created: {
      id: 'vocabulary_created',
      defaultMessage: 'Vocabulary created'
    },
    vocabulary_updated: {
      id: 'vocabulary_updated',
      defaultMessage: 'Vocabulary updated'
    },
    vocabulary_deleted: {
      id: 'vocabulary_deleted',
      defaultMessage: 'Vocabulary deleted'
    },
    settings_saved: {
      id: 'settings_saved',
      defaultMessage: 'Settings saved'
    },
    component_started: {
      id: 'component_started',
      defaultMessage: 'Component started'
    },
    component_restarted: {
      id: 'component_restarted',
      defaultMessage: 'Component restarted'
    },
    component_stopped: {
      id: 'component_stopped',
      defaultMessage: 'Component stopped'
    },
    restore_original_value: {
      id: 'restore_original_value',
      defaultMessage: 'Restore original value'
    },
    group_name: {
      id: 'group_name',
      defaultMessage: 'group name'
    },
    TOKEN_INVALID_OR_EXPIRED: {
      id: 'TOKEN_INVALID_OR_EXPIRED',
      defaultMessage: 'Token is out of date or does not exist'
    },
    SAMPLE_RATE_MISMATCH: {
      id: 'SAMPLE_RATE_MISMATCH',
      defaultMessage: 'Sampling rate mismatch'
    },
    TEXT_IS_TOO_LONG: {
      id: 'TEXT_IS_TOO_LONG',
      defaultMessage: 'Text is too long'
    },
    VOCABULARY_EXISTS: {
      id: 'VOCABULARY_EXISTS',
      defaultMessage: 'Vocabulary exists'
    },
    VOCABULARY_NOT_FOUND: {
      id: 'VOCABULARY_NOT_FOUND',
      defaultMessage: 'Vocabulary not found'
    },
    LDAP_SEARCH_ERROR: {
      id: 'LDAP_SEARCH_ERROR',
      defaultMessage: 'Error while performing a search in LDAP'
    },
    USER_DIRECTORY_NOT_FOUND: {
      id: 'USER_DIRECTORY_NOT_FOUND',
      defaultMessage: 'User directory is not found'
    },
    LDAP_GROUP_TO_POSITION_MAPPING_NOT_FOUND: {
      id: 'LDAP_GROUP_TO_POSITION_MAPPING_NOT_FOUND',
      defaultMessage: 'LDAP group-to-position mapping is not found'
    },
    USER_SID_NOT_SUPPORTED: {
      id: 'USER_SID_NOT_SUPPORTED',
      defaultMessage: 'Current LDAP version does not support SID. SID is available only for ActiveDirectory'
    },
    RESOURCE_VIOLATION: {
      id: 'RESOURCE_VIOLATION',
      defaultMessage: 'Failed to initialize session'
    },
    ROOT_MODIFICATION: {
      id: 'ROOT_MODIFICATION',
      defaultMessage: 'Root user cannot be modified'
    },
    ADMIN_POSITION_MODIFICATION: {
      id: 'ADMIN_POSITION_MODIFICATION',
      defaultMessage: 'Administrator position cannot be modified'
    },
    API_KEY_NOT_FOUND: {
      id: 'API_KEY_NOT_FOUND',
      defaultMessage: 'Key does not exist'
    },
    API_KEY_NOT_CORRECT: {
      id: 'API_KEY_NOT_CORRECT',
      defaultMessage: 'Empty key or string does not match key format'
    },
    API_KEY_IS_BLOCKED: {
      id: 'API_KEY_IS_BLOCKED',
      defaultMessage: 'Key is blocked'
    },
    API_KEY_EXPIRED: {
      id: 'API_KEY_EXPIRED',
      defaultMessage: 'Key is expired and no longer valid'
    },
    DOMAIN_NOT_FOUND: {
      id: 'DOMAIN_NOT_FOUND',
      defaultMessage: 'Domain is not found'
    },
    DOMAIN_ID_NOT_CORRECT: {
      id: 'DOMAIN_ID_NOT_CORRECT',
      defaultMessage: 'Invalid object: domainId field is empty, null or non-numeric'
    },
    ROLE_NOT_FOUND: {
      id: 'ROLE_NOT_FOUND',
      defaultMessage: 'Role is not found'
    },
    POSITION_NOT_FOUND: {
      id: 'POSITION_NOT_FOUND',
      defaultMessage: 'Position is not found'
    },
    PASSWORD_FOR_USER_NOT_SET: {
      id: 'PASSWORD_FOR_USER_NOT_SET',
      defaultMessage: 'Impossible to access the system. Password for this user is not set'
    },
    PASSWORD_IS_EMPTY: {
      id: 'PASSWORD_IS_EMPTY',
      defaultMessage: 'Invalid password: Password field is empty or null'
    },
    NOT_ENOUGH_PARAMETERS: {
      id: 'NOT_ENOUGH_PARAMETERS',
      defaultMessage: 'Not enough data for authentication. Specify user login and domain ID'
    },
    INVALID_ARGUMENT: {
      id: 'INVALID_ARGUMENT',
      defaultMessage: 'Date format is not dd.mm.yyyy hh:mm'
    },
    USER_DELETED: {
      id: 'USER_DELETED',
      defaultMessage: 'User is deleted'
    },
    API_KEY_NOT_SUPPORTED: {
      id: 'API_KEY_NOT_SUPPORTED',
      defaultMessage: 'Operations with the key are not available for the root user'
    },
    LABEL_NOT_FOUND: {
      id: 'LABEL_NOT_FOUND',
      defaultMessage: 'Label is not found'
    },
    RESOURCE_LABEL_NOT_FOUND: {
      id: 'RESOURCE_LABEL_NOT_FOUND',
      defaultMessage: 'Resource label is not found'
    },
    RESOURCE_NOT_FOUND: {
      id: 'RESOURCE_NOT_FOUND',
      defaultMessage: 'Resource is not found'
    },
    ROLE_LABEL_NOT_FOUND: {
      id: 'ROLE_LABEL_NOT_FOUND',
      defaultMessage: 'Role label is not found'
    },
    TEXT_VALUE_IS_NOT_DEFINE: {
      id: 'TEXT_VALUE_IS_NOT_DEFINE',
      defaultMessage: 'Text not found'
    },
    delete_label: {
      id: 'delete_label',
      defaultMessage: 'Delete label'
    },
    ROOT_LABEL_EXISTS_IN_DOMAIN: {
      id: 'ROOT_LABEL_EXISTS_IN_DOMAIN',
      defaultMessage: 'Root label already exists in the domain'
    },
    DUPLICATE_LABEL: {
      id: 'DUPLICATE_LABEL',
      defaultMessage: 'Label with the same name already exists'
    },
    impossible_get_data_types: {
      id: 'impossible_get_data_types',
      defaultMessage: 'Failed to get data types'
    },
    column_data_type: {
      id: 'column_data_type',
      defaultMessage: 'Column data type'
    },
    impossible_create_template: {
      id: 'impossible_create_template',
      defaultMessage: 'Failed to create template'
    },
    impossible_update_template: {
      id: 'impossible_update_template',
      defaultMessage: 'Failed to update template'
    },
    ALREADY_EXISTS: {
      id: 'ALREADY_EXISTS',
      defaultMessage: 'Template with the same name already exists'
    },
    impossible_get_templates: {
      id: 'impossible_get_templates',
      defaultMessage: 'Failed to get templates'
    },
    impossible_get_template: {
      id: 'impossible_get_template',
      defaultMessage: 'Failed to get template data'
    },
    impossible_get_reports: {
      id: 'impossible_get_reports',
      defaultMessage: 'Failed to get reports'
    },
    BAD_SQL_QUERY: {
      id: 'BAD_SQL_QUERY',
      defaultMessage: 'Incorrect SQL query'
    },
    WRONG_FIELDS: {
      id: 'WRONG_FIELDS',
      defaultMessage: 'Fields filled incorrectly'
    },
    result: {
      id: 'result',
      defaultMessage: 'Result'
    },
    visualizations: {
      id: 'visualizations',
      defaultMessage: 'Visualizations'
    },
    impossible_delete_template: {
      id: 'impossible_delete_template',
      defaultMessage: 'Failed to delete template'
    },
    plot: {
      id: 'plot',
      defaultMessage: 'Chart'
    },
    table: {
      id: 'table',
      defaultMessage: 'Table'
    },
    impossible_get_report_data: {
      id: 'impossible_get_report_data',
      defaultMessage: 'Failed to get report data'
    },
    impossible_start_schedule: {
      id: 'impossible_start_schedule',
      defaultMessage: 'Failed to start schedule'
    },
    impossible_pause_schedule: {
      id: 'impossible_pause_schedule',
      defaultMessage: 'Failed to pause schedule'
    },
    impossible_delete_schedule: {
      id: 'impossible_delete_schedule',
      defaultMessage: 'Failed to delete schedule'
    },
    impossible_create_schedule: {
      id: 'impossible_create_schedule',
      defaultMessage: 'Failed to create schedule'
    },
    impossible_update_schedule: {
      id: 'impossible_update_schedule',
      defaultMessage: 'Failed to update schedule'
    },
    week: {
      id: 'week',
      defaultMessage: 'Week'
    },
    custom: {
      id: 'custom',
      defaultMessage: 'Custom'
    },
    pause: {
      id: 'pause',
      defaultMessage: 'Pause'
    },
    start: {
      id: 'start',
      defaultMessage: 'Start'
    },
    template_created: {
      id: 'template_created',
      defaultMessage: 'Template created'
    },
    template_deleted: {
      id: 'template_deleted',
      defaultMessage: 'Template deleted'
    },
    template_updated: {
      id: 'template_updated',
      defaultMessage: 'Template updated'
    },
    WRONG_ARGUMENTS: {
      id: 'WRONG_ARGUMENTS',
      defaultMessage: 'Fields filled incorrectly'
    },
    'Current datetime': {
      id: 'Current datetime',
      defaultMessage: 'Current time'
    },
    'Current date': {
      id: 'Current date',
      defaultMessage: 'Current date'
    },
    empty_field: {
      id: 'empty_field',
      defaultMessage: 'Field is blank'
    },
    duplicated_value: {
      id: 'duplicated_value',
      defaultMessage: 'Duplicated value'
    },
    impossible_create_report: {
      id: 'impossible_create_report',
      defaultMessage: 'Failed to create report'
    },
    impossible_delete_report: {
      id: 'impossible_delete_report',
      defaultMessage: 'Failed to delete the report'
    },
    report_deleted: {
      id: 'report_deleted',
      defaultMessage: 'Report deleted'
    },
    incorrect_field: {
      id: 'incorrect_field',
      defaultMessage: 'Incorrect field value'
    },
    schedule_states_changed: {
      id: 'schedule_states_changed',
      defaultMessage: 'Schedule statuses changed'
    },
    schedule_deleted: {
      id: 'schedule_deleted',
      defaultMessage: 'Schedule deleted'
    },
    impossible_get_schedules_list: {
      id: 'impossible_get_schedules_list',
      defaultMessage: 'Failed to get list of schedules'
    },
    impossible_get_export_report_formats: {
      id: 'impossible_get_export_report_formats',
      defaultMessage: 'Failed to get report export formats'
    },
    impossible_export_report: {
      id: 'impossible_export_report',
      defaultMessage: 'Failed to export report'
    },
    impossible_get_privileges: {
      id: 'impossible_get_privileges',
      defaultMessage: 'Failed to get privileges'
    },
    impossible_get_scheduling_periods: {
      id: 'impossible_get_scheduling_periods',
      defaultMessage: 'Failed to get scheduling periods'
    },
    impossible_get_parameter_types: {
      id: 'impossible_get_parameter_types',
      defaultMessage: 'Failed to get parameter types'
    },
    FIELDS_VALIDATION_FAILED: {
      id: 'FIELDS_VALIDATION_FAILED',
      defaultMessage: 'Form not filled in correctly'
    },
    TEMPLATE_NOT_FOUND: {
      id: 'TEMPLATE_NOT_FOUND',
      defaultMessage: 'Template not found'
    },
    WRONG_PARAMETERS: {
      id: 'WRONG_PARAMETERS',
      defaultMessage: 'Parameters filled incorrectly'
    },
    impossible_get_schedule_data: {
      id: 'impossible_get_schedule_data',
      defaultMessage: 'Failed to get schedule data'
    },
    REPORT_NOT_FOUND: {
      id: 'REPORT_NOT_FOUND',
      defaultMessage: 'Report not found'
    },
    SCHEDULER_NOT_FOUND: {
      id: 'SCHEDULER_NOT_FOUND',
      defaultMessage: 'Schedule not found'
    },
    INCONSISTENT_RESULT: {
      id: 'INCONSISTENT_RESULT',
      defaultMessage: 'Table of the requested report in database does not match the report description'
    },
    UNSUPPORTED_FORMAT: {
      id: 'UNSUPPORTED_FORMAT',
      defaultMessage: 'Exporting to a file in this format is not supported'
    },
    WRONG_STATE: {
      id: 'WRONG_STATE',
      defaultMessage: 'Schedule status does not match the action'
    },
    ILLEGAL_ACTION: {
      id: 'ILLEGAL_ACTION',
      defaultMessage: 'SQL query contains one of the illegal instructions: "drop", "truncate" or "delete"'
    },
    SCHEDULE_STATE_RUNNING: {
      id: 'SCHEDULE_STATE_RUNNING',
      defaultMessage: 'In progress'
    },
    SCHEDULE_STATE_NEW: {
      id: 'SCHEDULE_STATE_NEW',
      defaultMessage: 'New'
    },
    SCHEDULE_STATE_PAUSED: {
      id: 'SCHEDULE_STATE_PAUSED',
      defaultMessage: 'Pause'
    },
    SCHEDULE_STATE_INVALID: {
      id: 'SCHEDULE_STATE_INVALID',
      defaultMessage: 'Does not match the template'
    },
    build_version_copied: {
      id: 'build_version_copied',
      defaultMessage: 'Build version copied successfully'
    },
    unable_to_copy_build_version: {
      id: 'unable_to_copy_build_version',
      defaultMessage: 'Failed to copy build version'
    },
    label_created: {
      id: 'label_created',
      defaultMessage: 'Label created'
    },
    label_deleted: {
      id: 'label_deleted',
      defaultMessage: 'Label deleted'
    },
    resource_updated: {
      id: 'resource_updated',
      defaultMessage: 'Resource updated'
    },
    LABEL_NOT_SUPPORTED: {
      id: 'LABEL_NOT_SUPPORTED',
      defaultMessage: 'Label editing operations are not available for root user'
    },
    USER_NOT_FOUND_BY_TOKEN: {
      id: 'USER_NOT_FOUND_BY_TOKEN',
      defaultMessage: 'Failed to find user by token'
    },
    ONLY_ACTIVE_ADMINS: {
      id: 'ONLY_ACTIVE_ADMINS',
      defaultMessage: 'Only active users with Administrator position are allowed to configure'
    },
    COMPONENT_NOT_FOUND: {
      id: 'COMPONENT_NOT_FOUND',
      defaultMessage: 'Component not found'
    },
    MALFORMED_DESCRIPTOR: {
      id: 'MALFORMED_DESCRIPTOR',
      defaultMessage: 'Description form is incorrect'
    },
    WRONG_INSTANCE_STATE: {
      id: 'WRONG_INSTANCE_STATE',
      defaultMessage: 'Instance must be off'
    },
    INSTANCE_NOT_FOUND: {
      id: 'INSTANCE_NOT_FOUND',
      defaultMessage: 'Instance not found'
    },
    VERSION_MISMATCH: {
      id: 'VERSION_MISMATCH',
      defaultMessage: 'Version mismatch'
    },
    NO_SPACE_LEFT_ON_DEVICE: {
      id: 'NO_SPACE_LEFT_ON_DEVICE',
      defaultMessage: 'Not enough memory on the device'
    },
    INVALID_STRUCTURE: {
      id: 'INVALID_STRUCTURE',
      defaultMessage: 'Invalid structure'
    },
    NO_DESCRIPTOR: {
      id: 'NO_DESCRIPTOR',
      defaultMessage: 'No description'
    },
    FACE_ID_NOT_DEFINED: {
      id: 'FACE_ID_NOT_DEFINED',
      defaultMessage: 'Profile ID is not set'
    },
    impossible_build_face_template: {
      id: 'impossible_build_face_template',
      defaultMessage: 'Impossible to build face template'
    },
    voice_template_created: {
      id: 'voice_template_created',
      defaultMessage: 'Voice template created'
    },
    profiles: {
      id: 'profiles',
      defaultMessage: 'Profiles'
    },
    verification_line_position_bottom: {
      id: 'verification_line_position_bottom',
      defaultMessage: 'Lower verification threshold'
    },
    verification_line_position_top: {
      id: 'verification_line_position_top',
      defaultMessage: 'Upper verification threshold'
    },
    optimal_verification_threshold: {
      id: 'optimal_verification_threshold',
      defaultMessage: 'Optimal verification threshold'
    },
    stopping_graph_during_silence: {
      id: 'stopping_graph_during_silence',
      defaultMessage: 'Stop the graph during silence'
    },
    similarity_measure: {
      id: 'similarity_measure',
      defaultMessage: 'Similarity measure'
    },
    candidate_photo: {
      id: 'candidate_photo',
      defaultMessage: 'Candidate photo'
    },
    // Переводы
    stop_record_and_save: {
      id: 'stop_record_and_save',
      defaultMessage: 'Stop recording and save'
    },
    minimum_verification_threshold: {
      id: 'minimum_verification_threshold',
      defaultMessage: 'Minimum verification threshold'
    },
    verify_speech: {
      id: 'verify_speech',
      defaultMessage: 'Verify speech'
    },
    failed_to_connect_device: {
      id: 'failed_to_connect_device',
      defaultMessage: 'Failed to connect device'
    },
    start_verification: {
      id: 'start_verification',
      defaultMessage: '# Начать верификацию'
    },
    end_verification: {
      id: 'end_verification',
      defaultMessage: '# Остановить верификацию'
    },
    verification_result: {
      id: 'verification_result',
      defaultMessage: '# Результат верификации'
    },
    similar_profiles: {
      id: 'similar_profiles',
      defaultMessage: '# Похожие профили'
    },
    speech_duration: {
      id: 'speech_duration',
      defaultMessage: '# Количество речи'
    },
    profile_information: {
      id: 'profile_information',
      defaultMessage: '# Информация о профиле'
    },
    photo_to_compare_with: {
      id: 'photo_to_compare_with',
      defaultMessage: '# Фото с которым сравниваем'
    },
    verify_photo: {
      id: 'verify_photo',
      defaultMessage: 'Верифицировать фото'
    },
    voice_template_collected_required_amount_of_speech: {
      id: 'voice_template_collected_required_amount_of_speech',
      defaultMessage: 'Voice template collected required amount of speech'
    },
    component_deleted: {
      id: 'component_deleted',
      defaultMessage: 'Component deleted'
    },
    ip_is_not_defined: {
      id: 'ip_is_not_defined',
      defaultMessage: 'IP is not defined'
    },
    server_name_is_not_defined: {
      id: 'server_name_is_not_defined',
      defaultMessage: 'Server name is not defined'
    },
    agent_demo_profile_id: {
      id: 'agent_demo_profile_id',
      defaultMessage: 'Profile ID'
    },
    agent_demo_name: {
      id: 'agent_demo_name',
      defaultMessage: 'Name'
    },
    agent_demo_last_name: {
      id: 'agent_demo_last_name',
      defaultMessage: 'Last name'
    },
    speech_quantity: {
      id: 'speech_quantity',
      defaultMessage: 'Speech quantity'
    },
    seconds: {
      id: 'seconds',
      defaultMessage: '{itemCount, plural, one {second} other {seconds}}'
    },
    UNDEFINED: {
      id: 'UNDEFINED',
      defaultMessage: '{itemCount, plural, one {second} other {seconds}}'
    },
    MALE: {
      id: 'MALE',
      defaultMessage: 'male'
    },
    FEMALE: {
      id: 'FEMALE',
      defaultMessage: 'female'
    },
    agent_demo_create_form_step_0: {
      id: 'agent_demo_create_form_step_0',
      defaultMessage: 'Create profile'
    },
    agent_demo_create_form_step_1: {
      id: 'agent_demo_create_form_step_1',
      defaultMessage: 'Build face model'
    },
    agent_demo_create_form_step_2: {
      id: 'agent_demo_create_form_step_2',
      defaultMessage: 'Build voice model'
    },
    agent_demo_create_form_create_profile: {
      id: 'agent_demo_create_form_create_profile',
      defaultMessage: 'Create profile'
    },
    agent_demo_create_form_skip_photo: {
      id: 'agent_demo_create_form_skip_photo',
      defaultMessage: 'Skip adding face model'
    },
    agent_demo_create_form_verify_add_photo: {
      id: 'agent_demo_create_form_verify_add_photo',
      defaultMessage: 'Verify and add face model'
    },
    agent_demo_create_form_skip_voice: {
      id: 'agent_demo_create_form_skip_voice',
      defaultMessage: 'Skip and finish'
    },
    agent_demo_create_form_add_voice_finish: {
      id: 'agent_demo_create_form_add_voice_finish',
      defaultMessage: 'Add voice model and finish'
    },
    can_not_update_agent_profile_name: {
      id: 'can_not_update_agent_profile_name',
      defaultMessage: 'Can\'t update profile name'
    },
    files: {
      id: 'files',
      defaultMessage: 'Files'
    },
    FILE_NOT_EXIST: {
      id: 'FILE_NOT_EXIST',
      defaultMessage: 'The file is not in the file storage'
    },
    CONFIGURATION_SAVE_TO_FILE_ERROR: {
      id: 'CONFIGURATION_SAVE_TO_FILE_ERROR',
      defaultMessage: 'Configuration file save error'
    },
    COMPONENT_MANAGEMENT_FAILED: {
      id: 'COMPONENT_MANAGEMENT_FAILED',
      defaultMessage: 'Failed to send component control command'
    },
    COMPONENT_MANAGEMENT_NOT_CONFIGURED: {
      id: 'COMPONENT_MANAGEMENT_NOT_CONFIGURED',
      defaultMessage: 'Component control configuration is not set'
    },
    HOST_MANAGEMENT_NOT_CONFIGURED: {
      id: 'HOST_MANAGEMENT_NOT_CONFIGURED',
      defaultMessage: 'Component host access configuration is not set'
    },
    INCORRECT_USERNAME: {
      id: 'INCORRECT_USERNAME',
      defaultMessage: 'Username to access the component host is not set'
    },
    INCORRECT_SSH_KEY_OR_PASSWORD_CONFIGURATION: {
      id: 'INCORRECT_SSH_KEY_OR_PASSWORD_CONFIGURATION',
      defaultMessage: 'SSH key or password to access the component host is not set'
    },
    MANAGEMENT_COMMAND_NOT_CONFIGURED: {
      id: 'MANAGEMENT_COMMAND_NOT_CONFIGURED',
      defaultMessage: 'Control command configuration is not set'
    }
  }
)
